import { RoutePage } from "@/components/RoutePage";
import { ApplicationsSection } from "@/components/sections/ApplicationsSection";

export default function ApplicationsPage({ onOpenContact }) {
  return (
    <RoutePage
      kicker="Applications"
      badge="A"
      accent="#8B5CF6"
      title="Future directions for brain health and performance."
      intro="These are research-stage platform directions — not clinical claims. Each represents a frontier where a closed-loop neuroplasticity platform could one day support meaningful work in research and care."
      primaryCta="Explore a use case"
      secondaryCta={{ href: "/team", label: "Meet the team" }}
      onOpenContact={onOpenContact}
      prev={{ href: "/ai", label: "AI" }}
      next={{ href: "/team", label: "Team" }}
      meta={{
        title: "Applications",
        description:
          "Research-stage platform directions for neurodegenerative research, motor rehabilitation, adaptive biofeedback, sleep and wellness, and drug-response modeling.",
        path: "/applications",
      }}
      stats={[
        { k: "5", v: "Future directions" },
        { k: "0", v: "Clinical claims" },
        { k: "Research", v: "-stage only" },
        { k: "Open", v: "Collaborations" },
      ]}
    >
      <ApplicationsSection />
    </RoutePage>
  );
}
